(function () {
    'use strict';
    /**
     * @memberof appback
     *@ngdoc service
     *@name WorkflowsService
     *@description
     *Workflows del usuario por tipo de contenido
     *(backend\controllers\WorkflowsController)
     */

    angular
        .module('appback')
        .factory('WorkflowsService', WorkflowsService);

    WorkflowsService.$inject = ["$http", "$q"];

    function WorkflowsService($http, $q) {

        var service = {
            Espacios: Espacios,
            CrearEspacio: CrearEspacio,
            EspacioDatos: EspacioDatos,
            GuardarEspacio: GuardarEspacio,
            Tipos: Tipos,
            Tareas: Tareas,
            Cargar: Cargar,
            Guardar: Guardar,
            CrearPrompt: CrearPrompt,
            EditarPrompt: EditarPrompt,
            Programaciones: Programaciones,
            BorrarContenido: BorrarContenido,
        };

        function datos(response) {
            if (!response.data || !response.data.success) {
                return $q.reject(response.data);
            }

            return response.data.data;
        }

        /**
         * Espacios activos ({id, name, icon, color, code, tipos}).
         */
        function Espacios() {
            return $http.get('/backend/workflows/espacios').then(datos);
        }

        /**
         * Crea un espacio (solo el admin, ver backend\models\EspacioForm).
         *
         * @param {Object} espacio name, icon, color y tipos (node_type de los tipos de contenido).
         * @return {id} del espacio creado.
         */
        function CrearEspacio(espacio) {
            return $http.post('/backend/workflows/crear-espacio', jQuery.param({
                name: espacio.name,
                icon: espacio.icon,
                color: espacio.color,
            }), {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then(datos, function (response) {
                return $q.reject(response.data);
            });
        }

        /**
         * Datos de la vista de un espacio (backend\controllers\WorkflowsController::actionEspacioDatos()).
         */
        function EspacioDatos(id) {
            return $http.get('/backend/workflows/espacio-datos', { params: { id: id } }).then(datos);
        }

        /**
         * Guarda los cambios de un espacio (solo el admin).
         *
         * @param {Object} espacio name, icon, color, tipos ({type, esPadre, tipoPadre}) y
         *   estados de las tareas, en orden ({id, name, backgroundColor, onBackgroundColor, isDefault}).
         */
        function GuardarEspacio(id, espacio) {
            return $http.post('/backend/workflows/guardar-espacio?id=' + encodeURIComponent(id), jQuery.param({
                name: espacio.name,
                icon: espacio.icon,
                color: espacio.color,
                tipos: espacio.tipos.map(function (tipo) {
                    return { type: tipo.type, esPadre: tipo.esPadre ? 1 : 0, tipoPadre: tipo.tipoPadre || '' };
                }),
                sinTipos: 1,
                estados: espacio.estados.map(function (estado) {
                    return { id: estado.id || '', name: estado.name, backgroundColor: estado.backgroundColor, onBackgroundColor: estado.onBackgroundColor, isDefault: estado.isDefault ? 1 : 0 };
                }),
            }), {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then(datos, function (response) {
                return $q.reject(response.data);
            });
        }

        /**
         * Tipos de contenido con el workflow del usuario para cada uno; con
         * espacioId, solo los de ese espacio.
         */
        function Tipos(espacioId) {
            return $http.get('/backend/workflows/tipos', { params: espacioId ? { espacioId: espacioId } : {} }).then(datos);
        }

        /**
         * Tasks disponibles ({slug, description}) para el selector de cada paso.
         */
        function Tareas() {
            return $http.get('/backend/workflows/tareas').then(datos);
        }

        /**
         * Workflows ([{id, activo, steps}]) del usuario para el tipo de contenido nodeType.
         */
        function Cargar(nodeType, espacioId) {
            return $http.get('/backend/workflows/cargar', { params: { nodeType: nodeType, espacioId: espacioId || '' } }).then(datos);
        }

        /**
         * @param {string} nodeType
         * @param {Object} workflow id (vacío para crear uno nuevo), activo, steps ({slug, orden, condition})
         *   y, desde el asistente, programacion opcional ({hora, dias, activo}) que se crea para él.
         * @return {id} del workflow guardado.
         */
        function Guardar(nodeType, workflow, espacioId) {
            // No llamarlo "datos": taparía la función datos() del .then() de abajo.
            var parametros = {
                nodeType: nodeType,
                spaceId: espacioId || '',
                id: workflow.id || '',
                titulo: workflow.titulo || '',
                activo: workflow.activo ? 1 : 0,
                // Solo lo tiene en cuenta el servidor si es el admin (ver HermesWorkflowForm::guardar()).
                isDefault: workflow.isDefault ? 1 : 0,
                steps: workflow.steps,
            };
            if (workflow.programacion) {
                parametros.programacion = workflow.programacion;
            }

            return $http.post('/backend/workflows/guardar', jQuery.param(parametros), {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then(datos, function (response) {
                return $q.reject(response.data);
            });
        }

        /**
         * Crea un prompt del usuario (backend\controllers\WorkflowsController::actionCrearPrompt()).
         *
         * @param {Object} prompt nombre, prompt y effortId (esfuerzo, vacío para el de por defecto).
         * @return tarea creada ({slug, description, tipo: 'prompt', prompt, effortId}).
         */
        function CrearPrompt(prompt) {
            return $http.post('/backend/workflows/crear-prompt', jQuery.param({
                nombre: prompt.nombre,
                prompt: prompt.prompt,
                effortId: prompt.effortId || '',
            }), {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then(datos, function (response) {
                return $q.reject(response.data);
            });
        }

        /**
         * Edita un prompt del usuario (backend\controllers\WorkflowsController::actionEditarPrompt()).
         *
         * @param {Object} prompt slug, nombre, prompt y effortId (esfuerzo, vacío para el de por defecto).
         * @return tarea editada ({slug, description, tipo: 'prompt', prompt, effortId}).
         */
        function EditarPrompt(prompt) {
            return $http.post('/backend/workflows/editar-prompt', jQuery.param({
                slug: prompt.slug,
                nombre: prompt.nombre,
                prompt: prompt.prompt,
                effortId: prompt.effortId || '',
            }), {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then(datos, function (response) {
                return $q.reject(response.data);
            });
        }

        /**
         * Borra un contenido de altcrm (lo deja inactivo). Es el mismo POST
         * que hace el grid de altcrm (content/borrarcontenido): su
         * content/delete no se puede usar, altcrm\components\AccessRuleContent
         * no contempla esa acción y responde 403.
         *
         * @param {string} url content/borrarcontenido (viene en la config de la vista).
         * @param {number} id Contenido a borrar.
         * @param {string} type nodeType del contenido.
         */
        function BorrarContenido(url, id, type) {
            return $http.post(url, jQuery.param({ id: id, type: type }), {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then(function (response) {
                // Contesta 200 con {code: 0} si no ha borrado nada.
                if (!response.data || !response.data.code) {
                    return $q.reject(response.data);
                }

                return response.data;
            }, function (response) {
                return $q.reject(response.data);
            });
        }

        /**
         * Programaciones ([{id, activo, hora, dias, diasTexto, ultima, proxima}]) del workflow workflowId.
         */
        function Programaciones(workflowId) {
            return $http.get('/backend/workflows/programaciones', { params: { workflowId: workflowId } }).then(datos);
        }

        return service;
    }
})();
